import endpoints from '@/constants/endpoints';
import axiosV2 from '@/data/api/axiosv2';
import { ITEMS_TABLE_PAGE_LIMIT } from '@/utils/constants';
import { GlobalOrdersResponse } from '../model/orders/globalOrdersDto';

export const getGlobalOrder = async (
  pageNumber: number
): Promise<GlobalOrdersResponse> => {
  const endpoint = endpoints.orders.getGlobalOrders;

  const response = await axiosV2.get<GlobalOrdersResponse>(endpoint, {
    params: {
      limit: ITEMS_TABLE_PAGE_LIMIT,
      page: pageNumber,
    },
  });

  return response;
};
